import {
  all, call, put, select, takeEvery,
} from 'redux-saga/effects';
import { selectEnterprise } from 'base/core/selectors';
import { selectAuthUser } from 'base/auth/selectors';
import { IRestApiResponse } from '../../interfaces';
import { request } from '../../utils/request';
import API from './constants';
import {
  DeleteNewsfeedPayload, GetNewsfeed, ICreateNewsfeedStateAction, PinNewsfeedPayload,
} from './interface';
import { newsfeedAction } from './components/newsfeed-list/slice';

export function* getNewsfeedListGenerator({ payload }: GetNewsfeed): any {
  try {
    const response: IRestApiResponse = yield call(
      request,
      {
        path: `${API.GET_FETCH_NEWSFEEDS.path}/?keyword=${payload.keyword}&page=${payload.page}&limit=${payload.limit}&sortBy=${payload.sortBy}`,
        method: API.GET_FETCH_NEWSFEEDS.method,
      },
      {},
      true,
      false,
    );
    if (response.statusCode === 201) {
      yield put(newsfeedAction.getNewsfeedsSucceeded(response.data));
    } else {
      yield put(newsfeedAction.getNewsfeedsFailed());
    }
  } catch (error) {
    yield put(newsfeedAction.getNewsfeedsFailed());
  }
}
export function* createNewsfeedGenerator({ payload }: ICreateNewsfeedStateAction): any {
  try {
    const { id: entId } = yield select(selectEnterprise);
    const expert = yield select(selectAuthUser);
    const expertId = expert.id;
    const response: IRestApiResponse = yield call(
      request,
      API.CREATE_NEWSFEED,
      {
        expertId,
        entId,
        ...payload,
      },
      true,
    );
    if (response.statusCode === 201) {
      yield put(newsfeedAction.createNewsfeedSucceeded());
      yield put(newsfeedAction.getNewsfeeds({
        keyword: '',
        page: 1,
        limit: 6,
        sortBy: 'Default',
      }));
      if (payload.resolve) {
        yield payload.resolve();
      }
    } else {
      yield put(newsfeedAction.createNewsfeedFailed());
      if (payload.reject) {
        yield payload.reject();
      }
    }
  } catch (error) {
    yield put(newsfeedAction.createNewsfeedFailed());
    if (payload.reject) {
      yield payload.reject();
    }
  }
}
export function* DeleteNewsFeed({ payload }: DeleteNewsfeedPayload): any {
  try {
    const id = payload;
    const response: IRestApiResponse = yield call(request, API.DELETE_NEWSFEED, { id }, true);
    if (response.statusCode === 201) {
      yield put(newsfeedAction.deleteNewsfeedItemSuccessed(payload));
    } else {
      yield put(newsfeedAction.deleteNewsfeedItemFailed());
    }
  } catch (error) {
    yield put(newsfeedAction.deleteNewsfeedItemFailed());
  }
}

export function* PinNewsFeedGenerator({ payload }: PinNewsfeedPayload): any {
  try {
    const id = payload;
    const response: IRestApiResponse = yield call(
      request,
      API.PIN_NEWSFEED,
      { id },
      true,
    );
    if (response.statusCode === 201) {
      yield put(newsfeedAction.pinNewsfeedItemSuccessed(payload));
    } else {
      yield put(newsfeedAction.pinNewsfeedItemFailed());
    }
  } catch (error) {
    yield put(newsfeedAction.pinNewsfeedItemFailed());
  }
}

export function* newsfeedsSaga() {
  yield all([
    takeEvery(
      newsfeedAction.getNewsfeeds.type,
      getNewsfeedListGenerator,
    ),
    takeEvery(
      newsfeedAction.deleteNewsfeedItem.type,
      DeleteNewsFeed,
    ),
    takeEvery(
      newsfeedAction.createNewsfeed.type,
      createNewsfeedGenerator,
    ),
    takeEvery(
      newsfeedAction.pinNewsfeedItem.type,
      PinNewsFeedGenerator,
    ),
  ]);
}

export default newsfeedsSaga;

export const newsfeedsSagas = {
  getNewsfeedListGenerator,
  createNewsfeedGenerator,
  DeleteNewsFeed,
  PinNewsFeedGenerator,
};
